export default __webpack_public_path__ + "static/media/medaille-bdo-argent-conception.cad8e17e.png";